"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyWordListDirectly = exports.shouldReplaceDirectly = exports.createFilter = void 0;
const createFilter = (callback, disabled) => {
    let isFirst = true;
    return (textChunk) => {
        if (disabled) {
            callback(textChunk);
        }
        else {
            const filteredChunk = isFirst ? textChunk.replace(/^\n+/, "") : textChunk;
            if (!filteredChunk)
                return;
            isFirst = false;
            callback(filteredChunk);
        }
    };
};
exports.createFilter = createFilter;
const shouldReplaceDirectly = (word) => {
    const specialCharacters = [" ", "　", "・", "=", "＝"];
    return specialCharacters.some((char) => word.includes(char));
};
exports.shouldReplaceDirectly = shouldReplaceDirectly;
const applyWordListDirectly = (text, wordList) => {
    const sortedWordList = [...wordList].sort((a, b) => b.text.length - a.text.length);
    let result = text;
    for (const word of sortedWordList) {
        if (word.translation &&
            word.text &&
            (0, exports.shouldReplaceDirectly)(word.translation)) {
            result = result.replace(new RegExp(word.text, "g"), word.translation);
        }
    }
    return result;
};
exports.applyWordListDirectly = applyWordListDirectly;
